export const dark = {
  backgroundColor: '#232533',
  fontColor: '#FDFDFE',
  second: '#585c68',

  card: {
    backgroundColor: '#313645',
    fontColor: '#FDFDFE',
    shadow: '0 0.5rem 2rem -1rem #191e2790',
  },
  nav: {
    background: '#7FBAFF',
    fontColor: '#FDFDFE',
    shadow: '0 0 3rem -1rem #191e2770',
  },
  accent: {
    blue: '#2196f3',
    red: '#f44336',
    yellow: '#ffeb3b',
    green: '#81c784',
  },
  borderRadius: 1,
};
